angular.module('zc')
  .component('zcIwNavigation', {
    templateUrl: '/templates/projects.iw/iw_navigation.html',
    bindings: {
      project: '<'
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.iw/iw_navigation.js